import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { portalApi, PORTAL_TOKEN_KEY } from "../lib/portalApi";

const PortalAuthContext = createContext(null);

export const PortalAuthProvider = ({ children }) => {
  const [me, setMe] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(PORTAL_TOKEN_KEY)) return setMe(false);
    try {
      const { data } = await portalApi.get("/portal/me");
      setMe(data);
    } catch {
      localStorage.removeItem(PORTAL_TOKEN_KEY);
      setMe(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onLogout = () => setMe(false);
    window.addEventListener("clover-portal-logout", onLogout);
    return () => window.removeEventListener("clover-portal-logout", onLogout);
  }, [refresh]);

  const login = useCallback(async (identifier, secret) => {
    const { data } = await portalApi.post("/portal/login", { identifier, secret });
    localStorage.setItem(PORTAL_TOKEN_KEY, data.access_token);
    await refresh();
  }, [refresh]);

  const logout = useCallback(() => {
    localStorage.removeItem(PORTAL_TOKEN_KEY);
    setMe(false);
  }, []);

  return <PortalAuthContext.Provider value={{ me, refresh, login, logout }}>{children}</PortalAuthContext.Provider>;
};

export const usePortalAuth = () => useContext(PortalAuthContext);
